<div class="container container-fluid">
  <!--     <div style=" color: green;"><b> Es esquema nuevo: {{preOrder.nuevo}} </b></div>
 -->
  <header class="banner">
    <img class="banner-img" [src]="promotionImages.getImage('mainHeader', '', 0, activePromotionName)" />
  </header>
  <section class="info-container">
    <p *ngIf="preOrder">
      <span
        >Estimado(a):
        <span class="b-text"
          >{{ nombre }} {{ primerApellido }} {{ segundoApellido }}
        </span></span
      ><br />
      <span
        >El día <span class="b-text">{{ preOrder?.fecha }}</span
        >, solicitaste la siguiente cotización en
        <span class="b-text"
          >Sucursal
          {{
            preOrder?.nombreSucursal + " (" + preOrder?.centro + ")"
              | nombreSucursal
          }}
        </span></span
      >
    </p>
    <div *ngIf="preOrder">
      <!-- COSTO FLETE -->
      <div
        style="
          border: 1px solid #ccc;
          padding: 10px;
          background-color: #f9f9f9;
          border-radius: 5px;
        "
      >
        <div *ngIf="preOrder?.precioFlete > 0 && hasItemWithFlete()">
          <div>
            <span
              >Costo estimado de envío:
              <span class="b-text">{{
                "$" + preOrder?.precioFlete
              }}</span></span
            >
          </div>
          <div>
            *** El costo de la entrega puede variar si la ubicación está fuera
            del rango de entrega.***
          </div>
          <div>
            *** El costo de la entrega puede variar si la entrega es express
            (mismo día) ***
          </div>
        </div>

        <div *ngIf="containtMotocicleta() == true">
          *** Pedidos de Motos no aplica para entrega a domicilio ***
        </div>
        <div *ngIf="containtCelular() == true">
          *** Pedidos de Celulares no aplica para entrega a domicilio  ***
        </div>
      </div>
    </div>

    <!-- <div *ngIf="preOrder && containtMotocicleta() == true">
            <div style="border: 1px solid #ccc; padding: 10px; background-color: #f9f9f9; border-radius: 5px;">
                <div>
                    <span>Pedidos de motos no aplica para entrega a domicilio</span>
                </div>
            </div>
        </div> -->
    <br />

    <div class="text-center">
      <div
        *ngIf="cargando && !errorCarga"
        class="spinner-border text-primary"
        role="status"
      >
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <div *ngIf="!cargando && errorCarga" class="text-center">
      <button type="button" (click)="init()" class="btn btn-primary">
        Reintentar
      </button>
    </div>

    <div *ngIf="!cargando && !errorCarga">
      <app-viewer-cotizacion-v1
        *ngIf="!preOrder.nuevo && orderContent"
        [orderContent]="orderContent"
        [centro]="preOrder.centro"
        [fecha]="preOrder.fecha"
      ></app-viewer-cotizacion-v1>
      <app-viewer-cotizacion-v2
        *ngIf="preOrder.nuevo && orderContentNuevo"
        [cotizacion]="orderContentNuevo"
        [fecha]="preOrder.fecha"
      ></app-viewer-cotizacion-v2>
    </div>

    <div class="whatsapp text-center">
      <img src="assets/img/whatsapp.png" class="icon" alt="" />
      <span>
        Haz válida tu cotización en tu sucursal de preferencia o bien da clic
        aquí:
        <a href="https://bit.ly/roga_landing" target="_blank" class="b-text"
          >(614)442.8202</a
        ></span
      >
    </div>
    <br />

    <span *ngIf="preOrder" class=""
      >Le Atendió con gusto:
      <span class="b-text"> {{ preOrder.nombreAgente }} </span>. Estoy a la
      orden en el teléfono:
      <span class="b-text"> {{ preOrder.telefonoSucursal }} </span></span
    >
  </section>
  <footer class="banner" style="background-color: #dee0e4">
    <img class="banner-img" [src]="promotionImages.getImage('mainFooter', '', 0, activePromotionName)" />
    <p class="text-right text-white mr-1">
      <small>
        v:{{ restService.versionApp }} -
        {{ restService.environmentName }}</small
      >
    </p>
  </footer>
</div>
